import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from "react-router-dom";

import {
  ChatOutlined,
  BarChartOutlined,
  Settings,
  HistoryOutlined,
  ChevronRight
} from '@material-ui/icons';
import {
  HeadsetMic,
  ConfirmationNumber,
  TimerOutlined,
  SearchOutlined,
  Brightness7,
  Brightness4,
  Assignment,
  CalendarMonth,
  CampaignOutlined,
  ChevronLeft,
  AutoAwesome,
  VideoLibrary,
  DashboardOutlined,
  CloudDownloadOutlined,
  UploadFileOutlined,
  GroupsOutlined,
  PeopleAltOutlined,
  Business,
  WhatsApp,
} from '@mui/icons-material';

import './left-sidebar.css';

import { setNotificationCount } from '../../redux/notification/notification.actions';
import { Box, Grid, IconButton, Modal, Popover, Switch, TextField, Tooltip, Typography, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import NotificationSound from '../../assets/notification_1.mp3'
import { useWebSocket } from '../../components/WebSocketContext/WebSocketContext';
import logoExpanded from '../../assets/sysfar-logo.png';
import logoCollapsed from '../../assets/icone SF.png';
import { selectViewedTickets, setViewedTickets } from '../../redux/ticket/ticket.actions';
import { toast } from 'react-toastify';
import http from '../../services/http';
import { PAGINA_DE_VIDEOS } from '../../utils/permissoesDaBase';

const LeftSideBar = props => {
  const [newClient, setNewClient] = useState([]);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { sincronizarConexoesDeSala, newMessageChats } = useWebSocket();
  const user = localStorage.getItem('user');
  const dispatch = useDispatch()
  const { permissions, isCollapsed = false, onToggleSidebar = () => { } } = props;
  const showLabels = !isCollapsed;
  const sidebarClassName = `left-sidebar ${isCollapsed ? 'collapsed' : 'expanded'}`;
  const getNavLinkClass = (path) => `nav-link ${props.location.pathname === path ? 'selected' : ''}`;
  const viewedTickets = useSelector(selectViewedTickets)
  const [modalOpen, setModalOpen] = useState(false);
  const [ticketId, setTicketId] = useState('');
  const [atendimentoAnchorEl, setAtendimentoAnchorEl] = useState(null);
  const atendimentoTimeoutRef = useRef(null);
  // Grupos de navegação com menu ao passar o mouse (padrão "Atendimento").
  const [ticketsAnchorEl, setTicketsAnchorEl] = useState(null);
  const ticketsTimeoutRef = useRef(null);
  const [clientesAnchorEl, setClientesAnchorEl] = useState(null);
  const clientesTimeoutRef = useRef(null);

  // Permissão para exibir o grupo "Atendimento" (Chat / Histórico / Painel)
  const canSeeAtendimentoMenu = Array.isArray(permissions)
    && permissions.some(p =>
      p === '/historico'
      || p === '/painel-atendimentos'
      || p === '#view-internal-tickets'
      || p === '#view-internal-comments'
    );
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleModalSubmit = async () => {
    // O operador digita o NUMERO que ve (protocolo por tenant), que desde a
    // numeracao por tenant nao e a PK: procurar por t.id abriria outro ticket.
    const numero = parseInt(ticketId, 10);
    // Procura primeiro na lista local (ativos já carregados). Se não achar —
    // caso típico de ticket resolvido/cancelado, que não vem na lista de ativos —
    // busca na API, que devolve o ticket em qualquer status (item 20).
    let ticket = numero ? props.tickets.tickets.find(t => t.number === numero) : null;
    if (!ticket && numero) {
      try {
        const res = await http.get(`/ticket/by-number/${numero}`);
        ticket = res?.data?.id
          ? { id: res.data.id, number: res.data.number, title: res.data.title }
          : null;
      } catch (e) {
        ticket = null;
      }
    }
    if (ticket) {
      // REGRA 1: Verifica se o ticket já existe PRIMEIRO
      const ticketExists = viewedTickets.some(t => t.id === ticket.id);
      
      // Se já existe, apenas navega (não altera ordem, não remove nada)
      if (ticketExists) {
        props.history.push(`/ticket/${ticket.id}`);
        handleModalClose();
        setTicketId('');
        return;
      }
      
      // REGRA 2: Se não existe, verifica limite ANTES de adicionar
      const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
      if (limitReached) {
        // Não adiciona ao QuickAccess se o limite foi atingido, mas navega mesmo assim
        // O toast será mostrado pelo QuickAccessUnified quando realmente detectar o limite
        props.history.push(`/ticket/${ticket.id}`);
        handleModalClose();
        setTicketId('');
        return;
      }
      
      // REGRA 3: Se passou na verificação, adiciona normalmente
      const updatedViewedTickets = [...viewedTickets, ticket];
      props.setViewedTickets(updatedViewedTickets);
      props.history.push(`/ticket/${ticket.id}`);
      handleModalClose();
      setTicketId('')
    } else {
      toast.error('Ticket não encontrado', {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          '& .Toastify__close-button': {
            color: theme.palette.text.primary,
          }
        }
      }
      );
      setTicketId('')
      handleModalClose();
    }
  };


  const [previousCount, setPreviousCount] = useState(props.count || 0);

  const updateBadgeCount = useCallback(() => {
    if (props.location.pathname === '/') {
      dispatch(setNotificationCount(0, props.roomId, 0)); // Resetar o contador
    } else {
      dispatch(setNotificationCount(newMessageChats.size, props.roomId, props.msg.length));
    }
  }, [dispatch, props.location.pathname, props.roomId, props.msg.length, newMessageChats.size]);

  useEffect(() => {
    updateBadgeCount(); // Chama para atualizar o contador sempre que a rota mudar
  }, [props.location.pathname, updateBadgeCount]);

  // SINCRONIZA as conexões com a lista, em vez de só abrir uma por sala.
  //
  // Antes isto só abria: percorria as salas chamando `addSocketConnection`, e a
  // limpeza que aquela função devolvia era descartada (ela é função comum, não
  // `useEffect`). Nenhuma conexão fechava -- dez salas em andamento viravam dez
  // conexões vivas, que sobreviviam à sala sair da lista. E como
  // `addSocketConnection` era redefinida a cada render e entrava nas
  // dependências, o efeito disparava a cada render e podia duplicar conexão.
  //
  // `sincronizarConexoesDeSala` é idempotente e estável (`useCallback` sem
  // dependências), então disparar de novo não cria nada.
  useEffect(() => {
    sincronizarConexoesDeSala(props.inProgressRooms);
  }, [props.inProgressRooms, sincronizarConexoesDeSala]);


  useEffect(() => {
    // Mantém o objeto criado para evitar que o bundler elimine o asset.
    new Audio(NotificationSound);

    // if (!("Notification" in window)) {
    //   console.log("Este navegador não suporta notificações de desktop");
    // } else if (Notification.permission === "granted") {
    //   if (props.count > previousCount && props.location.pathname !== '/') {
    //     new Notification("Você tem novas mensagens");
    //   }
    // } else if (Notification.permission !== "denied") {
    //   Notification.requestPermission().then(permission => {
    //     if (permission === "granted") {
    //       if (props.count > previousCount && props.location.pathname !== '/') {
    //         new Notification("Você tem novas mensagens");
    //       }
    //     }
    //   });
    // }

    setPreviousCount(props.count);
  }, [props.count, previousCount, props.location.pathname]);


  useEffect(() => {
    if (newClient !== undefined)
      if (props.waitingRooms.length !== newClient.length) {
        setNewClient(props.waitingRooms.length);
      }

  }, [props.waitingRooms, newClient]);

  useSelector(state => state.user.currentUser?.CRM_id);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === ' ') {
        handleModalOpen();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (atendimentoTimeoutRef.current) {
        clearTimeout(atendimentoTimeoutRef.current);
      }
    };
  }, []);

  // Estilos compartilhados dos grupos de navegação (botão de categoria + itens do menu).
  const categoryBoxSx = {
    cursor: 'pointer',
    width: isCollapsed ? '64px' : '100%',
    maxWidth: isCollapsed ? '64px' : '100%',
    display: 'flex',
    flexDirection: isCollapsed ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: isCollapsed ? 'center' : 'flex-start',
    padding: isCollapsed ? '8px 0' : '8px 12px',
    borderRadius: '14px',
    transition: 'all 0.3s ease',
    gap: isCollapsed ? 0 : 0.5,
    marginBottom: '2px',
    '&:hover': { background: 'rgba(255, 255, 255, 0.08)' },
  };
  const popoverMenuItemSx = {
    py: 1.5,
    px: 2,
    '&.Mui-selected': {
      backgroundColor: 'rgba(99, 165, 199, 0.1)',
      '&:hover': { backgroundColor: 'rgba(99, 165, 199, 0.15)' },
    },
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
  };

  const navMenuItem = (to, icon, label, onClose) => (
    <MenuItem
      key={to}
      component={Link}
      to={to}
      onClick={onClose}
      selected={props.location.pathname === to}
      sx={popoverMenuItemSx}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );

  // Renderiza um grupo de navegação com menu ao passar o mouse (padrão "Atendimento").
  const renderNavGroup = ({ icon, label, activePaths, anchorEl, setAnchorEl, timeoutRef, children }) => (
    <>
      <Box
        className={`nav-item category-item ${activePaths.includes(props.location.pathname) ? 'selected' : ''}`}
        onMouseEnter={(e) => {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
          setAnchorEl(e.currentTarget);
        }}
        onMouseLeave={() => {
          timeoutRef.current = setTimeout(() => setAnchorEl(null), 200);
        }}
        sx={categoryBoxSx}
      >
        {icon}
        {showLabels && (
          <>
            <Typography variant="caption" className="nav-label" sx={{ flex: 1, lineHeight: 1 }}>
              {label}
            </Typography>
            <ChevronRight sx={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)', ml: 'auto' }} />
          </>
        )}
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
        sx={{ pointerEvents: 'none', '& .MuiPopover-paper': { pointerEvents: 'auto' } }}
        PaperProps={{
          sx: {
            mt: 0,
            ml: isCollapsed ? 1 : 0.5,
            minWidth: 200,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
            borderRadius: '12px',
            overflow: 'hidden',
          },
        }}
      >
        <Box
          onMouseEnter={() => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
          }}
          onMouseLeave={() => {
            timeoutRef.current = setTimeout(() => setAnchorEl(null), 200);
          }}
          sx={{ py: 0.5 }}
        >
          {children}
        </Box>
      </Popover>
    </>
  );

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems={isCollapsed ? 'center' : 'stretch'}
      className={sidebarClassName}
    >
      <Grid item container direction="column" alignItems={isCollapsed ? 'center' : 'stretch'} className={'sidebar-main'}>
        <Grid
          item
          container
          direction="row"
          alignItems="center"
          justifyContent={isCollapsed ? 'center' : 'space-between'}
          wrap="nowrap"
          className={'sidebar-header'}
          spacing={0}
          sx={{
            width: '100%',
            alignSelf: 'stretch',
            maxWidth: '100%',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: isCollapsed ? 0.75 : 1,
            minHeight: 44,
          }}
        >
          <Grid
            item
            sx={{
              flex: isCollapsed ? '0 0 auto' : '1 1 auto',
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'center',
              justifyContent: isCollapsed ? 'center' : 'flex-start',
              lineHeight: 0,
            }}
          >
            <Link
              to="/"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 0,
                lineHeight: 0,
              }}
            >
              <img
                src={isCollapsed ? logoCollapsed : logoExpanded}
                alt="SysFar"
                className={isCollapsed ? 'sidebar-logo-collapsed' : 'sidebar-logo-expanded'}
              />
            </Link>
          </Grid>
          <Grid
            item
            sx={{
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'center',
              justifyContent: 'center',
            }}
          >
            <Tooltip
              title={isCollapsed ? 'Expandir menu lateral' : 'Recolher menu lateral'}
              placement="right"
              arrow
              enterDelay={350}
            >
              <IconButton
                size="small"
                onClick={onToggleSidebar}
                className="sidebar-toggle"
                aria-label={isCollapsed ? 'Expandir menu lateral' : 'Recolher menu lateral'}
                disableRipple
                sx={{
                  width: 30,
                  height: 30,
                  minWidth: 30,
                  p: 0,
                  borderRadius: '999px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  /*
                   * Claro sobre o navy, nos DOIS temas -- e nao pelo tema da
                   * aplicacao.
                   *
                   * Este botao vive dentro da barra lateral, cujo fundo e
                   * `--sidebar-shell-bg` (#2a4d69) tanto no claro quanto no
                   * escuro. Pintar pelo `palette.mode` fazia dele a unica
                   * peca da barra que mudava de cor com o tema: no claro o
                   * icone virava `text.primary` (quase preto) sobre o navy,
                   * medido em 2,01:1 -- abaixo do minimo de 3:1 para
                   * elemento de interface. O que decide a cor aqui e o fundo
                   * em que a peca esta, nao o tema da aplicacao.
                   */
                  color: 'rgba(255, 255, 255, 0.95)',
                  backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                  boxShadow: 'none',
                  transition:
                    'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.18s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.22)',
                    borderColor: 'rgba(255, 255, 255, 0.34)',
                    transform: 'scale(1.05)',
                  },
                  '&:active': {
                    transform: 'scale(0.96)',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }}
              >
                {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid item container direction="column" spacing={0} className={'nav-items-container'} sx={{ marginTop: isCollapsed ? '12px' : '0' }}>
          <Link to='/' className={getNavLinkClass('/')}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                marginBottom: '2px',
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <BarChartOutlined fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Indicadores
                </Typography>
              )}
            </Box>
          </Link>
          {/* Categoria Atendimento */}
          {canSeeAtendimentoMenu && (
            <>
              <Box
                className={`nav-item category-item ${(props.location.pathname === '/chat' || props.location.pathname === '/historico' || props.location.pathname === '/painel-atendimentos') ? 'selected' : ''}`}
                onMouseEnter={(e) => {
                  if (atendimentoTimeoutRef.current) {
                    clearTimeout(atendimentoTimeoutRef.current);
                  }
                  setAtendimentoAnchorEl(e.currentTarget);
                }}
                onMouseLeave={() => {
                  atendimentoTimeoutRef.current = setTimeout(() => {
                    setAtendimentoAnchorEl(null);
                  }, 200);
                }}
                sx={{
                  cursor: 'pointer',
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  borderRadius: '14px',
                  transition: 'all 0.3s ease',
                  gap: isCollapsed ? 0 : 0.5,
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.08)',
                  }
                }}
              >
                <HeadsetMic fontSize="small" className='icon' />
                {showLabels && (
                  <>
                    <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                      Atendimento
                    </Typography>
                    <ChevronRight
                      sx={{
                        fontSize: '0.9rem',
                        color: 'rgba(255, 255, 255, 0.6)',
                        ml: 'auto',
                      }}
                    />
                  </>
                )}
              </Box>
              <Popover
                open={Boolean(atendimentoAnchorEl)}
                anchorEl={atendimentoAnchorEl}
                onClose={() => setAtendimentoAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: isCollapsed ? 'right' : 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: isCollapsed ? 'left' : 'left',
                }}
                disableRestoreFocus
                sx={{
                  pointerEvents: 'none',
                  '& .MuiPopover-paper': {
                    pointerEvents: 'auto',
                  }
                }}
                PaperProps={{
                  sx: {
                    mt: 0,
                    ml: isCollapsed ? 1 : 0.5,
                    minWidth: 200,
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                    borderRadius: '12px',
                    overflow: 'hidden',
                  }
                }}
              >
                <Box
                  onMouseEnter={() => {
                    if (atendimentoTimeoutRef.current) {
                      clearTimeout(atendimentoTimeoutRef.current);
                    }
                  }}
                  onMouseLeave={() => {
                    atendimentoTimeoutRef.current = setTimeout(() => {
                      setAtendimentoAnchorEl(null);
                    }, 200);
                  }}
                  sx={{ py: 0.5 }}
                >
                  {permissions?.includes('#view-internal-tickets') ? (
                    <>
                      <MenuItem
                        component={Link}
                        to="/chat"
                        onClick={() => setAtendimentoAnchorEl(null)}
                        selected={props.location.pathname === '/chat'}
                        sx={{
                          py: 1.5,
                          px: 2,
                          '&.Mui-selected': {
                            backgroundColor: 'rgba(99, 165, 199, 0.1)',
                            '&:hover': {
                              backgroundColor: 'rgba(99, 165, 199, 0.15)',
                            }
                          },
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          }
                        }}
                      >
                        <ListItemIcon>
                          <ChatOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Chat" />
                      </MenuItem>
                    </>
                  ) : (
                    <Tooltip title="Por favor solicite um Código de Referência do Movidesk" arrow placement='right'>
                      <MenuItem disabled sx={{ py: 1.5, px: 2 }}>
                        <ListItemIcon>
                          <ChatOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Chat" />
                      </MenuItem>
                    </Tooltip>
                  )}
                  {(permissions?.includes('/historico') || permissions?.includes('#history-users')) && (
                    <MenuItem
                      component={Link}
                      to="/historico"
                      onClick={() => setAtendimentoAnchorEl(null)}
                      selected={props.location.pathname === '/historico'}
                      sx={{
                        py: 1.5,
                        px: 2,
                        '&.Mui-selected': {
                          backgroundColor: 'rgba(99, 165, 199, 0.1)',
                          '&:hover': {
                            backgroundColor: 'rgba(99, 165, 199, 0.15)',
                          }
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        }
                      }}
                    >
                      <ListItemIcon>
                        <HistoryOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Histórico" />
                    </MenuItem>
                  )}
                  {permissions?.includes('/painel-atendimentos') && (
                    <MenuItem
                      component={Link}
                      to="/painel-atendimentos"
                      onClick={() => setAtendimentoAnchorEl(null)}
                      selected={props.location.pathname === '/painel-atendimentos'}
                      sx={{
                        py: 1.5,
                        px: 2,
                        '&.Mui-selected': {
                          backgroundColor: 'rgba(99, 165, 199, 0.1)',
                          '&:hover': {
                            backgroundColor: 'rgba(99, 165, 199, 0.15)',
                          }
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        }
                      }}
                    >
                      <ListItemIcon>
                        <DashboardOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Painel de Atendimentos" />
                    </MenuItem>
                  )}
                </Box>
              </Popover>
            </>
          )}
          {renderNavGroup({
            icon: <ConfirmationNumber fontSize="small" className='icon' />,
            label: 'Tickets',
            activePaths: ['/ticket', '/dashboard-pendencias', '/tempo-tickets'],
            anchorEl: ticketsAnchorEl,
            setAnchorEl: setTicketsAnchorEl,
            timeoutRef: ticketsTimeoutRef,
            children: (
              <>
                {navMenuItem('/ticket', <ConfirmationNumber fontSize="small" />, 'Tickets', () => setTicketsAnchorEl(null))}
                {navMenuItem('/dashboard-pendencias', <DashboardOutlined fontSize="small" />, 'Pendências', () => setTicketsAnchorEl(null))}
                {permissions?.includes('/tempo-tickets') &&
                  navMenuItem('/tempo-tickets', <TimerOutlined fontSize="small" />, 'Tempo em tickets', () => setTicketsAnchorEl(null))}
              </>
            ),
          })}
          {permissions?.includes('/clientes/pesquisa') && renderNavGroup({
            icon: <PeopleAltOutlined fontSize="small" className='icon' />,
            label: 'Clientes',
            activePaths: ['/clientes/pesquisa', '/clientes/grupos'],
            anchorEl: clientesAnchorEl,
            setAnchorEl: setClientesAnchorEl,
            timeoutRef: clientesTimeoutRef,
            children: (
              <>
                {navMenuItem('/clientes/pesquisa', <SearchOutlined fontSize="small" />, 'Clientes', () => setClientesAnchorEl(null))}
                {navMenuItem('/clientes/grupos', <GroupsOutlined fontSize="small" />, 'Grupos', () => setClientesAnchorEl(null))}
              </>
            ),
          })}
          <Link to='/agenda' className={getNavLinkClass('/agenda')}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                marginBottom: '2px',
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <CalendarMonth fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Agenda
                </Typography>
              )}
            </Box>
          </Link>
          <Link to='/mural-avisos' className={getNavLinkClass('/mural-avisos')}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                marginBottom: '2px',
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <CampaignOutlined fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Mural
                </Typography>
              )}
            </Box>
          </Link>
          {permissions?.includes('/importar-movidesk') && (
          <Link to='/importar-movidesk' className={getNavLinkClass('/importar-movidesk')}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                marginBottom: '2px',
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <CloudDownloadOutlined fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Importar Movidesk
                </Typography>
              )}
            </Box>
          </Link>
          )}
          {permissions?.includes('/importar-clientes') && (
          <Link to='/importar-clientes' className={getNavLinkClass('/importar-clientes')}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                marginBottom: '2px',
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <UploadFileOutlined fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Importar clientes
                </Typography>
              )}
            </Box>
          </Link>
          )}
          {permissions?.includes('/ia-base-conhecimento') && (
            <Link to="/ia-base-conhecimento" className={getNavLinkClass('/ia-base-conhecimento')}>
              <Box
                className="nav-item"
                sx={{
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  gap: isCollapsed ? 0 : 0.5,
                  marginBottom: '2px',
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                }}
              >
                <AutoAwesome fontSize="small" className="icon" />
                {showLabels && (
                  <Typography variant="caption" className="nav-label" sx={{ flex: 1, lineHeight: 1 }}>
                    IA / Base de Conhecimento
                  </Typography>
                )}
              </Box>
            </Link>
          )}
          {/* Vídeos: MESMA permissão da base de conhecimento, porque é a
              mesma base recortada. Entrada própria no menu e não só um botão
              dentro da outra tela -- o pedido é uma "área específica para
              vídeos", e área que só se alcança por dentro de outra tela não
              é encontrada por quem não sabe que ela existe. */}
          {/* Permissão PRÓPRIA: é o que permite dar os vídeos a quem não pode
              abrir a IA / Base de Conhecimento, que é o pedido da Gisele para
              o perfil Operador. Com a permissão única, os dois links apareciam
              e sumiam juntos. */}
          {permissions?.includes(PAGINA_DE_VIDEOS) && (
            <Link to="/ia-base-conhecimento/videos" className={getNavLinkClass('/ia-base-conhecimento/videos')}>
              <Box
                className="nav-item"
                sx={{
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  gap: isCollapsed ? 0 : 0.5,
                  marginBottom: '2px',
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                }}
              >
                <VideoLibrary fontSize="small" className="icon" />
                {showLabels && (
                  <Typography variant="caption" className="nav-label" sx={{ flex: 1, lineHeight: 1 }}>
                    Vídeos e treinamentos
                  </Typography>
                )}
              </Box>
            </Link>
          )}
          {permissions?.includes('/whatsapp') && (
            <Link to="/whatsapp" className={getNavLinkClass('/whatsapp')}>
              <Box
                className="nav-item"
                sx={{
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  gap: isCollapsed ? 0 : 0.5,
                  marginBottom: '2px',
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                }}
              >
                <WhatsApp fontSize="small" className="icon" />
                {showLabels && (
                  <Typography variant="caption" className="nav-label" sx={{ flex: 1, lineHeight: 1 }}>
                    WhatsApp
                  </Typography>
                )}
              </Box>
            </Link>
          )}
        </Grid>
      </Grid>
      <Grid item container direction="column" justifyContent="flex-start" className='settings-bottom'>
        {permissions?.includes('/configuracoes') && (
          <Link to='/configuracoes' className={`${getNavLinkClass('/configuracoes')} settings-link`}>
            <Box
              className='nav-item'
              sx={{
                display: 'flex',
                flexDirection: isCollapsed ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                padding: isCollapsed ? '8px 0' : '8px 12px',
                gap: isCollapsed ? 0 : 0.5,
                width: isCollapsed ? '64px' : '100%',
                maxWidth: isCollapsed ? '64px' : '100%',
              }}
            >
              <Settings fontSize="small" className='icon' />
              {showLabels && (
                <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                  Configurações
                </Typography>
              )}
            </Box>
          </Link>
        )}
        {(() => {
          const currentUser = user ? JSON.parse(user) : null;
          const isAdmin = currentUser && (currentUser.profile_id === 1 || currentUser.is_super_admin);
          return isAdmin && (
            <Link to='/logs-atividades' className={`${getNavLinkClass('/logs-atividades')} settings-link`}>
              <Box
                className='nav-item'
                sx={{
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  gap: isCollapsed ? 0 : 0.5,
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                }}
              >
                <Assignment fontSize="small" className='icon' />
                {showLabels && (
                  <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                    Logs de Atividades
                  </Typography>
                )}
              </Box>
            </Link>
          );
        })()}
        {(() => {
          // Task 16 (Plataforma): estritamente `is_super_admin` -- diferente
          // do item de Logs acima, um admin comum de UM tenant (profile_id
          // 1) NÃO deve ver este item, só quem administra a plataforma
          // inteira. Isso é só conveniência de UI (a rota em App.js e a API
          // já bloqueiam de verdade quem não é super-admin).
          const currentUser = user ? JSON.parse(user) : null;
          const isSuperAdmin = !!(currentUser && currentUser.is_super_admin);
          return isSuperAdmin && (
            <Link to='/plataforma' className={`${getNavLinkClass('/plataforma')} settings-link`}>
              <Box
                className='nav-item'
                sx={{
                  display: 'flex',
                  flexDirection: isCollapsed ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  padding: isCollapsed ? '8px 0' : '8px 12px',
                  gap: isCollapsed ? 0 : 0.5,
                  width: isCollapsed ? '64px' : '100%',
                  maxWidth: isCollapsed ? '64px' : '100%',
                }}
              >
                <Business fontSize="small" className='icon' />
                {showLabels && (
                  <Typography variant="caption" className='nav-label' sx={{ flex: 1, lineHeight: 1 }}>
                    Plataforma
                  </Typography>
                )}
              </Box>
            </Link>
          );
        })()}
        <Box className={'theme-toggle-container'}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: isCollapsed ? 'column' : 'row',
              alignItems: 'center',
              justifyContent: isCollapsed ? 'center' : 'flex-start',
              padding: isCollapsed ? '8px 0' : '8px 12px',
              gap: isCollapsed ? 0 : 1.5,
              width: isCollapsed ? '64px' : '100%',
              maxWidth: isCollapsed ? '64px' : '100%',
            }}
          >
            {showLabels && !isCollapsed && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 28,
                  height: 28,
                  marginRight: '10px',
                  borderRadius: '50%',
                  background: theme.palette.mode === 'dark' 
                    ? 'linear-gradient(135deg, rgba(144, 202, 249, 0.2) 0%, rgba(66, 165, 245, 0.15) 100%)'
                    : 'linear-gradient(135deg, rgba(255, 193, 7, 0.25) 0%, rgba(255, 179, 0, 0.2) 100%)',
                  border: theme.palette.mode === 'dark'
                    ? '1px solid rgba(144, 202, 249, 0.3)'
                    : '1px solid rgba(255, 193, 7, 0.3)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    background: theme.palette.mode === 'dark'
                      ? 'radial-gradient(circle at 30% 30%, rgba(144, 202, 249, 0.4), transparent 70%)'
                      : 'radial-gradient(circle at 30% 30%, rgba(255, 193, 7, 0.4), transparent 70%)',
                    opacity: 0.6,
                  },
                }}
              >
                {theme.palette.mode === 'dark' ? (
                  <Brightness4 
                    sx={{ 
                      fontSize: '16px',
                      color: '#90caf9',
                      zIndex: 1,
                      filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2))',
                    }} 
                  />
                ) : (
                  <Brightness7 
                    sx={{ 
                      fontSize: '16px',
                      color: '#ffb300',
                      zIndex: 1,
                      filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))',
                    }} 
                  />
                )}
              </Box>
            )}
            {showLabels && (
              <Typography variant="caption" className='nav-label theme-label' sx={{ flex: 1, lineHeight: 1 }}>
                Tema
              </Typography>
            )}
              <Tooltip title={theme.palette.mode === 'dark' ? 'Alternar para tema claro' : 'Alternar para tema escuro'} placement={isCollapsed ? 'right' : 'top'} arrow>
                <Switch 
                  onClick={toggleTheme}
                  checked={theme.palette.mode === 'dark'} 
                  sx={{
                    width: 36,
                    height: 20,
                    padding: 0,
                    '& .MuiSwitch-switchBase': {
                      padding: 0,
                      margin: '1.5px',
                      transitionDuration: '200ms',
                      '&.Mui-checked': {
                        transform: 'translateX(16px)',
                        color: '#fff',
                        '& + .MuiSwitch-track': {
                          backgroundColor: 'rgba(255, 255, 255, 0.3)',
                          opacity: 1,
                          border: 0,
                        },
                        '& .MuiSwitch-thumb': {
                          backgroundColor: '#fff',
                        },
                      },
                    },
                    '& .MuiSwitch-thumb': {
                      boxSizing: 'border-box',
                      width: 17,
                      height: 17,
                      backgroundColor: '#fff',
                      transition: 'all 200ms ease',
                      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.15)',
                    },
                    '& .MuiSwitch-track': {
                      borderRadius: 10,
                      backgroundColor: '#e9ecef',
                      opacity: 1,
                      transition: 'background-color 200ms ease',
                    },
                  }}
                >
                </Switch>
              </Tooltip>
          </Box>
        </Box>
      </Grid>

      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'transparent' }}
      >
        <Box sx={{
          bgcolor: theme.palette.background.modal, color: theme.palette.text.primary,
          padding: '1rem', maxWidth: '45vw', display: 'flex',
          flexDirection: 'column', flexWrap: 'nowrap', flex: 1, borderRadius: '8px',
          boxShadow: '0 0 15px #484747'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Ir direto ao Ticket
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            id="ticket-id"
            label="Protocolo"
            type="text"
            fullWidth
            variant="standard"
            value={ticketId}
            onChange={(e) => setTicketId(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleModalSubmit(e);
              }
            }}
          />
        </Box>
      </Modal>

    </Grid>
  );
}

const mapStateToProps = state => {
  const { rooms, notification, user, tickets } = state;
  const { waitingRooms } = rooms;
  const { permissions } = user;
  return {
    waitingRooms, count: state.notification.count,
    msg: state.notification.messages,
    old: state.notification.oldMessage,
    roomId: state.notification.roomId,
    inProgressRooms: rooms.inProgressRooms,
    notification,
    permissions,
    tickets
  };
};

const mapDispatchToProps = dispatch => ({
  setViewedTickets: tickets => dispatch(setViewedTickets(tickets)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeftSideBar));